const map = require('lodash.map');
const baseUrl = '../..';
module.exports = function serviceUrl(service, params) {
    let paramString = map(params, (value,key) => `${key}=${value}`).join('&');
    if(paramString)
        paramString = '&' + paramString;
    return `${baseUrl}/Services.aspx?service=${service}${paramString}`;
}
